export const INCREMENT_FOLLOWING_COUNT = 'currentUser/INCREMENT_FOLLOWING_COUNT';
export const DECREMENT_FOLLOWING_COUNT = 'currentUser/DECREMENT_FOLLOWING_COUNT';

export const incrementFollowingCount = currentUserId => ({ type: INCREMENT_FOLLOWING_COUNT, payload: currentUserId });
export const decrementFollowingCount = currentUserId => ({ type: DECREMENT_FOLLOWING_COUNT, payload: currentUserId });



// WEBPACK FOOTER //
// ./app/actions/increment-following-count.js